<template>
  <v-text-field
    v-model="valueTextLocale"
    dense
    outlined
    hide-details
    :label="label"
    :filled="filled"
    :disabled="disabled"
    :readonly="readonly"
    :rules="rules"
    @change="$emit('input-changed', { value: $event })"
  >
    <template
      v-if="mostrarIcones"
      v-slot:prepend
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </template>
  </v-text-field>
</template>

<script>
import { computed, ref, watchEffect } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import Icons from './Icons.vue'
import ComponenteBase from './ComponenteBase.vue'
import textComponentMixin from '@/mixins/textComponentMixin'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  mixins: [textComponentMixin],

  setup(props) {
    const isRequired = computed(() => (props.obrigatorio && !props.readonly ? required : true))
    const rules = props.validarTamanho ? [isRequired.value, v => v.length <= props.maxLength] : [isRequired.value]

    const valueTextLocale = ref('')
    watchEffect(() => { valueTextLocale.value = props.valueText })

    return {
      isRequired,
      rules,
      valueTextLocale,
    }
  },
}
</script>
